import React from 'react'
import { Outlet } from 'react-router-dom';
import Footers from '../components/common/Footers';
import Menu from '../components/common/Menu';
import ResponsiveMenu from '../components/common/ResponsiveMenu';
import Submenu from '../components/common/Submenu';


const HomeLayout = ({ children,setregister }) => {
  return (
    <div className='HomeLayout'>
      <Menu />
      <ResponsiveMenu/>
      <Submenu/>
      <main id='target' reference='target' className='main-user'>
        <Outlet />
      </main>
      <Footers/>
 
    </div>
  )
}

export default HomeLayout